import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Title } from 'app/components';
import React from 'react';
import { CachedArticleRetrievalListComp } from './components';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 3, 8),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 2, 6),
    },
  },
}));

const CachedArticleRetrievalList = ({ routeType = 'account' }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Title prefix="Cached Article Retrieval" />
      <CachedArticleRetrievalListComp routeType={routeType} />
    </Box>
  );
};

export default CachedArticleRetrievalList;
